<script lang="ts">
import type { WindowWika } from '../../types/window';
import { mergeSwitchWtParams } from '../../utils/tracking';
import Flag from '../Flag/Flag.vue';

type EventTeaser = {
  category: string;
  city: string;
  date: string;
  image: string;
  location: string;
  name: string;
  primaryLink: string;
  secondaryLink: string;
  wtParams?: object;
};

type Props = {
  data: EventTeaser;
  wtParams: {
    doctype: string;
  };
};

const _window = window as unknown as WindowWika;
</script>

<script setup lang="ts">
const { data } = defineProps<Props>();

const { wtTrack } = _window;

const mergeWtParams = (globalWtParams: object, itemWtParams: object, itemParams?: object) =>
  mergeSwitchWtParams(globalWtParams, itemWtParams, itemParams);
</script>

<template>
  <figure :class="$style.container">
    <a
      :class="$style.mediaLink"
      :href="data.primaryLink"
      target="_self"
      @click="
        data.wtParams &&
        wtTrack?.(
          {
            cat: wtParams.doctype,
          },
          mergeWtParams(
            wtParams,
            {
              filename: data.primaryLink,
            },
            {},
          ),
        )
      "
    >
      <img :alt="data.name" :src="data.image" />
    </a>
    <figcaption>
      <a :class="$style.secondaryLink" :href="data.secondaryLink">{{ data.category }}</a>
      <a
        :class="$style.primaryLink"
        :href="data.primaryLink"
        @click="
          data.wtParams &&
          wtTrack?.(
            {
              cat: wtParams.doctype,
            },
            mergeWtParams(
              wtParams,
              {
                filename: data.primaryLink,
              },
              {},
            ),
          )
        "
      >
        <h3>{{ data.name }}</h3>
        <div>{{ data.date }}</div>
        <div><Flag />{{ data.city }}</div>
        <div>{{ data.location }}</div>
      </a>
    </figcaption>
  </figure>
</template>

<style module lang="scss" src="./EventTeaser.scss" />
